import { useEffect, useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { PHONE_DISPLAY, PHONE_TEL, scrollToId } from "../lib/site";

const LINKS = [["Coverage", "coverage"], ["Process", "process"], ["About", "about"], ["FAQ", "faq"]];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  const go = (id) => { setOpen(false); scrollToId(id); };

  return (
    <header data-testid="site-header" className={`fixed top-0 inset-x-0 z-50 transition-[background-color,padding,box-shadow] duration-500 ${scrolled || open ? "bg-[#071510]/90 backdrop-blur-xl py-3 shadow-[0_1px_0_rgba(255,255,255,0.08)]" : "py-6"}`}>
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 flex items-center justify-between">
        <button onClick={() => go("top")} data-testid="nav-logo-btn" aria-label="Back to top"><Logo light /></button>
        <nav className="hidden lg:flex items-center gap-10">
          {LINKS.map(([l, id]) => (
            <button key={id} onClick={() => go(id)} data-testid={`nav-link-${id}`} className="group relative text-sm text-[#F4F1EA]/85 hover:text-white transition-colors">
              {l}
              <span className="absolute -bottom-1 left-0 h-px w-full bg-[#E5A855] origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" />
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a href={`tel:${PHONE_TEL}`} data-testid="nav-call-link" className="hidden md:flex items-center gap-2 font-mono-d text-xs text-[#F4F1EA] hover:text-[#E5A855] transition-colors">
            <Phone className="w-4 h-4" /> {PHONE_DISPLAY}
          </a>
          <button onClick={() => go("quote")} data-testid="nav-quote-btn" className="hidden sm:inline-flex rounded-full bg-[#E5A855] text-[#071510] px-5 py-2.5 text-sm font-semibold hover:bg-[#FAF8F5] transition-colors">
            Free Quote
          </button>
          <button onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" className="lg:hidden text-[#FAF8F5] p-2" aria-label="Menu">
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden px-5 pt-6 pb-8 flex flex-col gap-5" data-testid="nav-mobile-menu">
          {LINKS.map(([l, id]) => (
            <button key={id} onClick={() => go(id)} data-testid={`mobile-nav-link-${id}`} className="text-left font-serif-d text-3xl text-[#FAF8F5]">{l}</button>
          ))}
          <button onClick={() => go("quote")} data-testid="mobile-nav-quote-btn" className="mt-2 rounded-full bg-[#E5A855] text-[#071510] px-5 py-3 font-semibold">Get a Free Quote</button>
          <a href={`tel:${PHONE_TEL}`} data-testid="mobile-nav-call-link" className="font-mono-d text-sm text-[#F4F1EA]">Call {PHONE_DISPLAY}</a>
        </div>
      )}
    </header>
  );
};
